<template>
    <div>
        <Row :gutter="10" type="flex" justify="start">
            <Col :span="6">
            <RadioGroup v-model="searchForm.timeType" type="button" button-style="solid" style="width: 100%;display:flex;padding:0">
                <Radio label="day" style="width:calc(100% / 3);text-align: center;">日报</Radio>
                <Radio label="week" style="width:calc(100% / 3);text-align: center;">周报</Radio>
                <Radio label="month" style="width:calc(100% / 3);text-align: center;">月报</Radio>
            </RadioGroup>
            </Col>
            <Col :span="6">
            <DatePicker :editable="false" transfer format="yyyy-MM-dd" type="daterange" style="width: 100%;" :options="options"
                placeholder="请选择日期" :value="listDate" @on-change="getListDate" :clearable="false"></DatePicker>
            </Col>
            <Col :span="3">
            <Select transfer  v-model="searchForm.personIds"
                placeholder="请选择优化师" filterable :max-tag-count="1" multiple>
                <template #prefix>
                    <a v-show="searchForm.personIds.length" style="font-size: 12px;padding: 0 5px;white-space:nowrap"
                        @click="(e) => {
                            e.preventDefault()
                            e.stopPropagation();
                            searchForm.personIds = []
                        }">清空</a>
                </template>
                <Option v-for="(i, index) in searchOptions.person" :key="index" :value="i.id">{{ i.dictName }}
                </Option>
            </Select>
            </Col>
            <Col :span="3">
            <Select v-model="searchForm.langIds" transfer placeholder="请选择语言" :max-tag-count="1" clearable multiple filterable>
                      <Option v-for="(item,index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}</Option>
                </Select>
            </Col>
            <Col :span="3">
            <Select transfer placeholder="广告系列状态" clearable v-model="searchForm.campaignStatus">
                <Option value="CAMPAIGN_ACTIVE">开启</Option>
                <Option value="CAMPAIGN_PENDING">加载中</Option>
                <Option value="CAMPAIGN_DISABLE">关闭</Option>
            </Select>
            </Col>
            <Col :span="3">
            <Select transfer placeholder="推广渠道" clearable v-model="searchForm.channels" multiple  :max-tag-count="1">
                <Option :value="0">facebook</Option>
                <Option :value="1">tiktok</Option>
                <Option :value="2">google</Option>
            </Select>
            </Col>
            <Col :span="3" style="margin-top: 10px">
                <Select transfer placeholder="推广目标" clearable v-model="searchForm.advertiseType">
                    <Option :value="0">W2A</Option>
                    <Option :value="1">直投</Option>
                </Select>
            </Col>
            <Col :span="3">
                <Select transfer  v-model="searchForm.timezoneOffset"
                    placeholder="时区偏移量" filterable style="margin-top: 10px;">
                    <Option :value="-8" label="美国时间">美国时间(西八区 UTC-8)</Option>
                    <Option :value="0" label="世界标准时间">世界标准时间(UTC+0)</Option>
                    <Option :value="8" label="北京时间">北京时间(东八区 UTC+8)</Option>
                </Select>
            </Col>
            <Col :span="3" style="margin-top: 10px">
                <Select transfer placeholder="短剧名称或短剧id" v-model="searchForm.playIds" clearable multiple filterable :max-tag-count="1">
                    <template #prefix>
                        <a v-show="searchForm.playIds.length" style="font-size: 12px;padding: 0 5px;white-space:nowrap"
                            @click="(e) => {
                                e.preventDefault()
                                e.stopPropagation();
                                searchForm.playIds = []
                            }">清空</a>
                    </template>
                    <Option v-for="(item, index) in playList" :key="index" :value="item.playId" :label="item.playCnName"
                        style="width: 300px;overflow:hidden;display:flex">
                        {{ item.playCnName }}
                        <div style="width: 1000px;flex-shrink: 0;"></div>
                        {{ item.id }}
                        {{ item.playName }}
                    </Option>
                </Select>
            </Col>
            <Col :span="6" style="margin-top: 10px">
                <Select v-model="searchForm.advertiseSeriesIds" placeholder="请选择广告系列" filterable :max-tag-count="1" multiple
                    transfer :remote-method="handleGetCampaign"
                    :loading="campaignLoading">
                    <template #prefix>
                        <a v-show="searchForm.advertiseSeriesIds.length"
                            style="font-size: 12px;padding: 0 5px;white-space:nowrap" @click="(e) => {
                                e.preventDefault()
                                e.stopPropagation();
                                searchForm.advertiseSeriesIds = []
                            }">清空</a>
                    </template>
                    <Option v-for="(i, index) in campaigns" :key="index" :value="i.campaignId" :label="i.campaignName">
                        {{ i.campaignName }}
                    </Option>
                </Select>
            </Col>
            <Col style="margin-top: 10px;" :span="3">
            <Button  type="primary" @click="handleSearchData">搜索</Button>
            <!-- <Button style="margin: 0 0 0 10px" @click="handleReset">重置</Button> -->
            </Col>
            <div style="flex-grow: 1;text-align: right;margin-top: 10px;padding-right: 12px;padding: 0 5px">
                <Tooltip transfer content="点击下载">
                    <Button style="padding:4px 5px" :loading="exportLoading"
                        @click="handleExport">
                        <Icon type="md-download" :size="20" />
                    </Button>
                </Tooltip>
                <Tooltip transfer content="自定义列">
                    <Button style="margin-left: 10px;padding:4px 5px" @click="visible = true">
                        <Icon type="md-options" :size="20" />
                    </Button>
                </Tooltip>
                
            </div>
        </Row>
        <div style="display: flex;flex-wrap: wrap;">
            
            
            
            
        </div>
        <Modal v-model="visible" :width="1000" title="自定义字段编辑" footer-hide>
            <fieldSelector v-model="column" :orgin="flagColumn" @upload:visible="visible=false" @upload:column="submitColumn"  />
        </Modal>
        <Drawer v-model="drawerVisible" :width="50">
            <span style="font-size:16px">广告系列{{ drawIndex?'分国家':'分时' }}数据</span>
            <span style="color: #aaa;font-size:14px;margin-left:10px">{{ drawerForm.campaignName }}</span>
            <Table border ref="roiRef" :loading="drawerLoading" style="margin-top: 50px;" :columns="drawIndex?countryColumnClone.map(i => ({ ...i, align: 'center' })):drawerColumnClone.map(i => ({ ...i, align: 'center' }))"
                :data="drawerData">
            </Table>
        </Drawer>
        <Tables ref="tableRef" style="margin-top: 20px;" :column="columns" :func="getPitcherCampaign"
            :searchForm="searchForm" />
    </div>
</template>

<script>
import dayjs from 'dayjs'
import { drawerColumn, countryColumn } from '.'
import { debounce } from 'lodash'
import { getPitcherCampaign, getCampainInitNew, exportCampaign, getPlay, getHourData, getCountryData } from '@/api/data'
import { columnData } from '../index'
import draggable from 'vuedraggable';
import { cloneDeep } from 'lodash'
import Tables from '../Table.vue';
import fieldSelector from '../../../../../components/fieldSelector/index.vue'
export default {
    name: 'Campaign',
    components: {
        draggable,
        Tables,
        fieldSelector
    },
    props: {
        searchOptions: {
            type: Object,
            default: () => ({
                person: [],
                campaign: []
            })
        },
        flag: {
            type: Number | String,
            default: 1
        },
        langList: {
            type: Array,
            default: ()=>([])
        }
    },
    data() {
        return {
            options: {
                    shortcuts: [
                        {
                            text: '今日',
                            value () {
                                return [dayjs().add(-16, 'hour').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        },
                        {
                            text: '近三天',
                            value () {
                                return [dayjs().add(-16, 'hour').add(-2,'day').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        },
                        {
                            text: '近七天',
                            value () {
                                return [dayjs().add(-16, 'hour').add(-6,'day').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        },
                        {
                            text: '近一个月',
                            value () {
                                return [dayjs().add(-16, 'hour').add(-1,'month').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        }
                    ],},
            keyword: '',
            visible: false,
            getPitcherCampaign,
            drawerColumnClone: [],
            drawerColumn,
            countryColumnClone: [],
            countryColumn,
            drawerForm: {},
            campaigns: [],
            drawerLoading:false,
            drawerData: [],
            searchForm: {
                timeType: 'day',
                advertiseSeriesIds: [],
                personIds: [],
                channels: [],
                timezoneOffset: -8,
                playIds: []
            },
            drawIndex: 0,
            exportLoading: false,
            columnData,
            flagColumn: [],
            newColumn: [],
            column: [],
            columns: [],
            drawerVisible: false,
            tempColumn: [],
            playLoading: false,
            campaignLoading: false,
            listDate: [],
            playList: []
        }
    },
    inject: ['parent'],
    watch: {
        flag(){
            const li = [...this.column]
                        this.column = []
                        this.column = li.map(i => {
                            const obj = this.newColumn.find(j=>j.key.includes(i))||{}
                            if (obj.flag&&this.flag == 1) {
                                return i.replaceAll('All', 'New')
                            } else if (obj.flag&&this.flag == 2) return i.replaceAll('New', 'All')
                            return i
                        })
                        this.flagColumn = this.newColumn.filter(i => !i.flag || i.flag == this.flag)
                        this.drawerColumnClone = drawerColumn.filter(i => !i.flag || i.flag == this.flag)
                        this.countryColumnClone = countryColumn.filter(i => !i.flag || i.flag == this.flag)
                        this.submitColumn()
        },
        visible() {
            this.column = this.columns.map(i => i.key)
        }
    },
    methods: {
        dragStart() {
            this.tempColumn = [...this.column]
        },
        handleGetCampaign: debounce(function (query) {
            if (!query) {
                this.campaigns = []
                this.campaignLoading = false
            } else {
                this.campaignLoading = true
                getCampainInitNew({
                    current: 1,
                    campaignName: query,
                    size: 200
                }).then(r => {
                    this.campaigns = r.data.records
                    this.campaignLoading = false
                })
            }
        }, 700),
        dragEnd(row) {
            const indexli = this.flagColumn.filter(i => i.always).map((i, index) => index)
            if (indexli.includes(row.newIndex) || indexli.includes(row.oldIndex)) this.column = [...this.tempColumn]
        },
        handleSearchData() {
            this.$refs.tableRef.handleGetData()
        },
        submitColumn() {
            this.columns = this.column
                .map(i => {
                    const obj = this.newColumn.find(j => j.key == i)
                    return obj ? {
                        title: obj.title,
                        key: obj.key,
                        index: obj.index,
                        fixed: obj.fixed,
                        unit: obj.unit,
                        width: obj.width,
                        needCalc: obj.needCalc,
                        maxWidth: obj.maxWidth,
                        tooltip: !!obj.tooltip,
                        tooltipMaxWidth: obj.tooltipMaxWidth,
                        notFixed: obj.notFixed,
                        slot: obj.slot,
                        resizable: true,
                        calc: obj.calc,
                        sortable: !obj.sortable ? false : 'custom',
                        render: obj.render
                    } : null
                })
                .filter(Boolean)
            this.visible = false
            localStorage.setItem('user-campaign', JSON.stringify(this.columns))
            localStorage.setItem('user-campaign-flag', this.flag)

        },
        handleGetPlay: debounce(function (query) {
            // if (!query) {
            //     this.playList = []
            //     this.playLoading = false
            // } else {
                this.playLoading = true
                getPlay({
                    current: 1,
                    name: query,
                    size: 10000
                }).then(r => {
                    this.playList = r.data.records
                    this.playLoading = false
                })
            // }
        }, 700),
        getListDate(data) {
            this.listDate = data
            this.searchForm.startDate = data[0]
            this.searchForm.endDate = data[1]
            this.parent.searchDate = data
        },
        handleReset() {
            this.searchForm = {
                advertiseSeriesIds: [],
                personIds: [],
                timezoneOffset: -8,
                channels: [],
                playIds: [],
                timeType: 'day'
            }
            this.getListDate([dayjs().add(-16, 'hour').format('YYYY-MM-DD'), dayjs().add(-16, 'hour').format('YYYY-MM-DD')])

        },
        
        handleResetColumn() {
            this.column = this.flagColumn.filter(i => i.always).map(i => i.key)
        },
        handleExport() {
            this.exportLoading = true
            exportCampaign({
                ...this.searchForm
            }).then(r => {
                const link = document.createElement('a')
                link.style.display = 'none'
                link.href = r.data.fileUrl
                // link.href = window.location.origin + r.data.fileUrl.substring(r.data.fileUrl.indexOf('/s_excel'), r.data.fileUrl.length)
                link.setAttribute('download', r.data.fileName)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.exportLoading = false
            }).catch(e => {
                this.exportLoading = false
            })
        },
        handleOpenDrawer(row,index) {
            this.drawerForm = {}
            this.drawerForm = row
            this.drawIndex = index
            this.drawerLoading = true
            this.drawerVisible = true
            this.$nextTick(()=>{
                const scroll = this.$refs.roiRef.$el.querySelector(".ivu-table-body");
                const fixed = this.$refs.roiRef.$el.querySelector(".ivu-table-fixed-body");
                
                // 监听滚轮
                scroll &&
                    scroll.addEventListener(
                    "mousewheel",
                    (e) => {
                        if (scroll.scrollLeft <= 0 && e.deltaX < 0) {
                            e.preventDefault();
                        }
                    },
                    {
                        passive: false,
                    }
                    );
                fixed &&
                    fixed.addEventListener("wheel", (e) => {
                        if(e.deltaX)e.preventDefault();
                    });
            })
            if(!index){
                getHourData({
                    advertiseSeriesIds: [row.campaignId],
                    // startDateTime: dayjs(this.searchForm.endDate).format('YYYY-MM-DD HH:mm:ss')
                }).then(r => {
                    this.drawerData = r.data
                    this.drawerLoading = false
                }).catch(e => {
                    this.drawerLoading = false
                })
            }else{
                getCountryData({
                    advertiseSeriesIds: [row.campaignId],
                    timeType: this.searchForm.timeType,
                    startDate: this.searchForm.startDate,
                    endData: this.searchForm.endDate,
                    statDate: row.statDate,
                    current: 1,
                    size: 300
                }).then(r => {
                    this.drawerData = r.data.pageData?r.data.pageData.records : []
                    this.drawerLoading = false
                }).catch(e => {
                    this.drawerLoading = false
                })
            }
        }
    },
    mounted() {
        this.drawerColumn.find(i => i.key == 'cost').render = (h, params) => {
            const max = Math.max(...this.drawerData.map(i => Number(i.cost)))
            return <div 
            style={{ 
                display:'flex',
                alignItems:'center',
                justifyContent: 'center',
                position: 'absolute',
                inset: 0,
                background: params.row.cost?'linear-gradient(rgba(187, 247, 208, 1) 0%, rgba(187, 247, 208, 1) 100%)':'', backgroundSize: ((params.row.cost / max) * 100).toFixed(2) + 'px', backgroundRepeat: 'no-repeat' }}>
                {params.row.cost}
            </div>
        }
        this.countryColumn.find(i => i.key == 'cost').render = (h, params) => {
            const max = Math.max(...this.drawerData.map(i => Number(i.cost)))
            return <div 
            style={{ 
                display:'flex',
                alignItems:'center',
                justifyContent: 'center',
                position: 'absolute',
                inset: 0,
                background: params.row.cost?'linear-gradient(rgba(187, 247, 208, 1) 0%, rgba(187, 247, 208, 1) 100%)':'', backgroundSize: ((params.row.cost / max) * 100).toFixed(2) + 'px', backgroundRepeat: 'no-repeat' }}>
                {params.row.cost}
            </div>
        }
        const li = cloneDeep(this.columnData.filter(i => !i.only || i.only.includes('campaign')))
        li.map(i => {
            if (i.key == 'campaignName') {
                i.render = (h, params) => {
                    return <Tooltip style="width:100%" transfer>
                        <div style={{ cursor: 'pointer', whiteSpace: 'nowrap', width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', color:'#2d8cf0' }} onClick={
                            () => {
                                this.parent.extraData = {}
                                this.parent.tabIndex = '2'
                                this.parent.extraData = {
                                    advertiseSeriesIds: [params.row.campaignId]
                                }
                                this.parent.selectOption = []
                                this.parent.selectOption = [params.row.campaignId, params.row.campaignName]
                            }
                        }>{params.row.campaignName}</div>
                        <div slot="content">
                            <p style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                                <span style="white-space: normal">{params.row.campaignName}</span>
                                <br />
                                <br />
                                {params.row.campaignId}
                                </p>
                        </div>
                    </Tooltip>
                }
            }
            if (i.key == 'status') {
                i.render = (h, params) => {
                    return <div style="display:flex;justify-content:space-between;">
                            <div style="color: #2d8cf0;cursor:pointer" onClick={() => this.handleOpenDrawer(params.row,0)}>
                                分时
                            </div>
                            <div style="color: #2d8cf0;cursor:pointer;margin-left:10px" onClick={() => this.handleOpenDrawer(params.row,1)}>
                                分国家
                            </div>
                        </div>
                }
            }

        })
        this.newColumn = li
        this.newColumn[1].always = true
        this.newColumn[1].fixed = 'left'
        this.flagColumn = this.newColumn.filter(i => !i.flag || i.flag == this.flag)
        try {
            const column = localStorage.getItem('user-campaign')
            if (column) {
                const parsedColumn = JSON.parse(column)
                this.column = parsedColumn.map(i => i.key)
            } else {
                this.column = [...this.flagColumn].map(i => i.key)
            }
        } catch (e) {
            // 处理JSON解析错误或无效数据
            this.column = [...this.flagColumn].map(i => i.key)
        }
        this.drawerColumnClone = drawerColumn.filter(i => !i.flag || i.flag == this.flag)
        this.countryColumnClone = countryColumn.filter(i => !i.flag || i.flag == this.flag)


        const date = this.parent.searchDate
        this.handleReset()
        if (date && date.length) {
            // this.searchForm.startDate = JSON.parse(date)[0]
            // this.searchForm.endDate = JSON.parse(date)[1]
            this.getListDate([date[0], date[1]])
        }
        
        if (Object.keys(this.parent.extraData).length) {
            this.searchForm = {
                ...this.searchForm,
                ...this.parent.extraData
            }
            this.parent.extraData = {}
        }
        this.submitColumn()
        
        this.$nextTick(()=>{
            this.handleSearchData()
                const scroll = this.$refs.tableRef.$el.querySelector(".ivu-table-body");
                const fixed = this.$refs.tableRef.$el.querySelector(".ivu-table-fixed-body");
                
                // 监听滚轮
                scroll &&
                    scroll.addEventListener(
                    "mousewheel",
                    (e) => {
                        if (scroll.scrollLeft <= 0 && e.deltaX < 0) {
                            e.preventDefault();
                        }
                    },
                    {
                        passive: false,
                    }
                    );
                fixed &&
                    fixed.addEventListener("wheel", (e) => {
        if(e.deltaX)e.preventDefault();

                    e.preventDefault();
                    });
        })
    },
    activated() {
        this.handleGetPlay()
        const li = [...this.column]
                        this.column = []
                        this.column = li.map(i => {
                            const obj = this.newColumn.find(j=>j.key.includes(i))||{}
                            if (obj.flag&&this.flag == 1) {
                                return i.replaceAll('All', 'New')
                            } else if (obj.flag&&this.flag == 2) return i.replaceAll('New', 'All')
                            return i
                        })
                        this.flagColumn = this.newColumn.filter(i => !i.flag || i.flag == this.flag)
                        this.drawerColumnClone = drawerColumn.filter(i => !i.flag || i.flag == this.flag)
                        this.countryColumnClone = countryColumn.filter(i => !i.flag || i.flag == this.flag)
                        this.submitColumn()
        const date = this.parent.searchDate
        if (date && date.length) {
            // this.searchForm.startDate = JSON.parse(date)[0]
            // this.searchForm.endDate = JSON.parse(date)[1]
            this.getListDate([date[0], date[1]])
        }
        if (Object.keys(this.parent.extraData).length) {
            this.searchForm = {
                ...this.searchForm,
                ...this.parent.extraData
            }
            
            this.parent.extraData = {}
            this.$nextTick(()=>{
                this.handleSearchData()
            })
        }

    }
}
</script>

<style lang="less" scoped>
.checkbox {
    margin: 0 -10px;
    overflow: hidden;
    width: 100%;
    &>* {
        width: 50%;
        flex: 0 50%;
        padding: 5px 10px;
        font-size: 16px;
    }
}

/deep/.ivu-table td,
.ivu-table th {
    height: 30px;
}

/deep/.ivu-table-wrapper{
    border-color: #fff;
}

/deep/.ivu-table {
    .ivu-table-tbody {
        // .ivu-table-row:last-child {
        //     height: 30px;

        //     td {
        //         vertical-align: top;
        //         height: 30px;
        //     }
        // }

    }

    td {
        position: relative;

    }
}
/deep/.ivu-checkbox{
    margin-right: 10px;
}
/deep/ .ivu-table-border{
    th, td{
        border-color: #fff;

    }
}
/deep/.ivu-table-fixed{
    pointer-events: none;
    &>*{
        pointer-events: auto;
    }
}
</style>